import getIn from '../utils/getIn'
import isInApp from './isInApp'

const padl = window[window.config.padl.namespace].dataLayer
const page = padl.page.page.pageInfo
const app = padl.app.app
const platform = (app.landscape === 'NC2-mosaic' || app.landscape === 'NC2-classic') ? 'desktop' : 'mobile'
const isResponsive = getIn('config.responsiveModeEnabled', window)
const breadcrumbUID = page.breadcrumbUID
let technology = breadcrumbUID.split(':')[4] || 'originalline'
if (technology === 'originalline') {
    technology = 'original'
} else if (technology === 'vertuoline') {
    technology = 'vertuo'
}

export default {
    channel: page.segmentBusiness,
    platform,
    country: app.market,
    language: page.language,
    isInApp,
    isProd: app.isEnvironmentProd,
    currency: app.currency,
    breadcrumbUID,
    technology,
    pageName: page.pageName,
    isMosaic: app.landscape === 'NC2-mosaic' && !isResponsive,
    isResponsive,
    isMobile: platform === 'mobile',
    isClassic: app.landscape === 'NC2-classic'
}
